import { Config } from '../../config'

export const stellarConfig: Config = {
  partner: 'stellar',
  catalog: 'partner',
  displayName: 'Stellar Scientific',
  accentColor: '#008bc5',
  host: 'seating.stellarscientific.com',
}

